// recentColors — Modern パレットの「最近色 (最近使った色)」純ロジック (段階1、consult 2026-06-12).
//
// ## 役割 (重要): 作業色の代用ではなく「使ったが残さなかった色」の救済ネット
//   ModernColorPalette は旧版16色の **ライブ編集スロット** (= 選択スロットがホイールに
//   追従して即書き換わる、保存ボタン無し)。ライブ編集は **選択スロットを上書きするので
//   前の色が消える**。その取りこぼしを拾う **履歴ネット** として最近色行を足す。
//   → 最近色 = ユーザが settle した描画色 (= chrome.pen.color) の履歴。
//
// ## 本ファイルは純ロジックのみ (state は useRecentColors / React 側)
//   - `pushRecentColor(list, color)`: most-recent-first、dedupe、最大 RECENT_COLORS_MAX。
//     既出色は **先頭へ繰り上げ** (= 二重に増やさず最新使用順を保つ)。
//   - 「ホイールドラッグ中の中間色で溢れさせない」のは **記録タイミング** (= settle した
//     色だけ push する) の責務で、これは useRecentColors のデバウンスが担う。本純関数は
//     「与えられた色を正しく畳み込む」だけ (= デバウンスは持たない)。
//
// Modern スコープ完結 (= 共有 useRoomChrome / Classic / engine には手を入れない)。

/** 最近色行のスロット数 (= 16色スロットの 8 列に合わせ 1 行)。 */
export const RECENT_COLORS_MAX = 8;

/**
 * 最近色リストに `color` (= rgb24) を畳み込む。
 *   - most-recent-first (先頭が最新)。
 *   - dedupe: 既出色は重複させず **先頭へ繰り上げ**る (= 最新使用順を反映)。
 *   - 最大 `RECENT_COLORS_MAX` 件 (= 溢れた末尾を切る)。
 *
 * 与えられた `color` をそのまま信頼して畳み込む純関数。「中間ドラッグ色で溢れさせない」
 * (= settle した色だけ入れる) のは呼び出し側 (useRecentColors のデバウンス) の責務。
 */
export const pushRecentColor = (
  list: ReadonlyArray<number>,
  color: number,
): ReadonlyArray<number> => {
  // rgb24 に正規化 (= 上位ビット混入を防ぎ、スウォッチ hex 化と一致させる / dedupe 安定)。
  const c = color & 0xffffff;
  const withoutDup = list.filter((x) => x !== c);
  return [c, ...withoutDup].slice(0, RECENT_COLORS_MAX);
};
